import axios from 'axios';
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';

import Select from 'react-select';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import DateInput from '../Common-Components/DateInput';
import DropdownInput from '../Common-Components/DropdownInput';
import FileInput from '../Common-Components/FileInput';
import Input from '../Common-Components/Input';
import TinyEditor from '../Common-Components/TinyEditor';
import { getBlogCategories, setDropDownStyle } from '../CommonHelper';
import '../Course/Course.css';
import { checkExistingItem } from '../common-helpers/commonServices';
// import { fetchBlogData, formateBlogData } from './BlogHelper';


const AboutModal = forwardRef((props, ref) => {
    let initialFormData = {
        Title: '',
        TitleHeading: '',
        Description: '',
        Category: '',
        MetaTitle: '',
        MetaDescription: '',
        PublishDate: new Date(),
        Tag: '',
        WrittenBy: "",
        Image: '',
    }
    const [modalBox, setModalBox] = useState(false);
    const [blogId, setBlogId] = useState('');
    const [formData, setFormData] = useState(initialFormData);




    useImperativeHandle(ref, () => ({
        openModal(Sn) {
            setBlogId(Sn);
            setModalBox(true);
            if (Sn) {
                axios.get(BACKEND_SERVER_URL + `/AboutDetails/${Sn}`).then((response) => {
                    setFormData(response.data.data);
                    console.log(response.data);
                }
                ).catch((error) => {
                    toast.error(error.response.data.message)
                    console.log(error)
                })

            } else {
                setFormData(initialFormData);
            }

        }
    }));
    console.log(formData)
    const handleChange = (name, value) => {
        setFormData((formData) => (
            { ...formData, [name]: value }
        ));
    };
    //console.log(formData)
    const handleSubmitBlog = () => {
        axios.post(BACKEND_SERVER_URL + (blogId ? `/updateAbout/${blogId}` : '/createAbout'), formData).then((response) => {
            console.log(response.data);
            setFormData(initialFormData)
            toast.success(response.data.message)
            props.setBlogsLoading(!props.loadBlogs)
            setModalBox(false);
        }).catch((error) => {
            toast.error(error.response.data.message)
            console.log(error)
        })

    }
    useEffect(() => {
        if (!modalBox) {
            setFormData(initialFormData);
        }
    }, [modalBox]);

    return (
        <>
            <Modal className="" show={modalBox} onHide={setModalBox} dialogClassName="custom-modal-width" backdrop="static"
                keyboard={false} >
                <Modal.Header>
                    <Modal.Title>{blogId ? 'Update Blog' : 'Create Blog'}</Modal.Title>
                    <Button variant="" className="btn-close" onClick={() => setModalBox(false)}></Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 d-flex justify-content-around ">
                                <div className="col-5 d-flex">
                                    <Input inputType="text" handleChangeCallBack={handleChange} labelName="Title" inputValue={formData?.Title} inputName='Title' divSizes={[4, 8]} />
                                </div>
                                <div className="col-5 d-flex">
                                    <Input inputType="text" handleChangeCallBack={handleChange} labelName="URL Title" inputValue={formData?.TitleHeading} inputName='TitleHeading' divSizes={[4, 8]} />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around  ">
                                <div className="col-5 d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Category" inputType="text" inputValue={formData?.Category} inputName='Category' divSizes={[4, 8]} />
                                </div>

                                <div className="col-5 d-flex align-items-center">
                                    <DateInput labelName="Publish Date" selected={formData?.PublishDate} handleChangeCallBack={handleChange} inputName='PublishDate' />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around  ">
                                <div className="col-5 d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Written By" inputType="text" inputValue={formData?.WrittenBy} inputName='WrittenBy' divSizes={[4, 8]} />
                                </div>

                                <div className="col-5 d-flex align-items-center">

                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <TinyEditor handleChangeCallBack={handleChange} labelName="Description" inputValue={formData?.Description} inputName='Description' />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <FileInput handleChangeCallBack={handleChange} labelName="Image" inputType="text" uploadedFileURL={formData?.Image} inputName='Image' accept="image/jpeg, image/png, image/gif" />
                                </div>
                            </div>
                            {/* <div className="col-12 ">
                                <div className="d-flex">
                                    <FileInput handleChangeCallBack={handleChange} labelName="Image" inputType="text" uploadedFileURL={formData?.imageURL} inputName='imageURL' accept="image/jpeg, image/png, image/gif" />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Image Alt" inputType="text" inputValue={formData?.imageAlt} inputName='imageAlt' divSizes={[2, 10]} />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Image Caption" inputType="text" inputValue={formData?.imageCaption} inputName='imageCaption' divSizes={[2, 10]} />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Image Title" inputType="text" inputValue={formData?.imageTitle} inputName='imageTitle' divSizes={[2, 10]} />
                                </div>
                            </div> */}
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Tags" inputType="text" inputValue={formData?.Tag} inputName='Tag' divSizes={[2, 10]} />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Meta Title" inputType="text" inputValue={formData?.MetaTitle} inputName='MetaTitle' divSizes={[2, 10]} />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <Input handleChangeCallBack={handleChange} labelName="Meta Description" inputType="textarea" inputValue={formData?.MetaDescription} inputName='MetaDescription' divSizes={[2, 10]} />
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger light" className='btn-sm' onClick={() => setModalBox(false)}>Close</Button>
                    <Button variant="primary " className='btn-sm ' onClick={handleSubmitBlog}>{blogId ? 'Update Blogs' : 'Create Blogs'}</Button>
                </Modal.Footer>
            </Modal>


        </>
    )
})
export default AboutModal;